export const ORDER_CONTAINERS_SECTION_SPACING = '2rem';
